








































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import UploadIntegrationData from '@/components/Admin/Panels/UploadIntegrationData.vue';
import PreviewIntegration from '@/components/Admin/Panels/PreviewIntegration.vue';
import PreviewIntegrationOutput from '@/components/Admin/Panels/PreviewOutput.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import { dateTimeFormatWithSeconds } from '@/ts/DefaultTableConfigs';
import IntegrationData from '@/ts/IntegrationData';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        AddButton,
        UploadIntegrationData,
        PreviewIntegration,
        PreviewIntegrationOutput,
        FlexibleTable,
    },
    computed: {
        ...mapGetters({
            integrations: 'Integrations/getIntegrations',
            integrationData: 'Integrations/currentIntegrationData',
            addIntegrationVisibility: 'Integrations/getAddIntegrationVisibility',
            previewIntegrationVisibility: 'Integrations/getPreviewIntegrationVisibility',
            previewIntegrationOutputVisibility: 'Integrations/getCurrentIntegrationOutputOverlayVisibility',
        }),
    },
})
export default class Integrations extends Mixins(DateMethods, NotifyMethods) {
    public currentIntegrationId: number = null;
    public tableEntity: string = 'IntegrationsList';

    public columns: any = [
        { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
        { name: 'filename', label: this.$t('general.filename', 'Filename'), align: 'left', field: 'filename', sortable: true, required: false },
        { name: 'filesize', label: this.$t('general.filesize', 'File size'), field: 'filesize', align: 'left', sortable: true, required: false, filter: true,
            sort: (a: any, b: any) => {
                const aSize = this.$options.filters.stringToBytes(a);
                const bSize = this.$options.filters.stringToBytes(b);

                return aSize - bSize;
            },
        },
        { name: 'createdAt', label: this.$t('integrations.uploaded-at', 'Uploaded at'), align: 'left', field: 'createdAt', sortable: true, filterType: 'date', dateTimeFormatWithSeconds,
            sort: (a: any, b: any) => {
                const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormatWithSeconds).valueOf() : 0;
                const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormatWithSeconds).valueOf() : 0;

                return aTimestamp - bTimestamp;
            },
        },
        { name: 'runAt', label: this.$t('integrations.run-at', 'Run at'), align: 'left', field: 'runAt', sortable: true, filterType: 'date', dateTimeFormatWithSeconds,
            sort: (a: any, b: any) => {
                const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormatWithSeconds).valueOf() : 0;
                const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormatWithSeconds).valueOf() : 0;

                return aTimestamp - bTimestamp;
            },
        },
        { name: 'processedAt', label: this.$t('integrations.processed-at', 'Processed at'), align: 'left', field: 'processedAt', sortable: true, filterType: 'date', dateTimeFormatWithSeconds,
            sort: (a: any, b: any) => {
                const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormatWithSeconds).valueOf() : 0;
                const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormatWithSeconds).valueOf() : 0;

                return aTimestamp - bTimestamp;
            },
        },
        { name: 'failedAt', label: this.$t('integrations.failed-at', 'Failed at'), align: 'left', field: 'failedAt', sortable: true, filterType: 'date', dateTimeFormatWithSeconds,
            sort: (a: any, b: any) => {
                const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormatWithSeconds).valueOf() : 0;
                const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormatWithSeconds).valueOf() : 0;

                return aTimestamp - bTimestamp;
            },
        },
    ];

    constructor() {
        super();
    }

     get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'fileName',
                'filesize',
                'createdAt',
            ],
        };
    }

    get corporationId() {
        return this.$store.getters['User/getCorporationId'];
    }

    public buttonText(integrationData: IntegrationData): string {
        let buttonText = this.$t('integrations.import', 'Import Data');

        if (integrationData.imported) {
            buttonText = this.$t('integrations.imported', 'Imported');
        } else if (integrationData.disabled) {
            buttonText = this.$t('integrations.import-disabled', 'Import Disabled');
        } else if (integrationData.processing) {
            buttonText = this.$t('integrations.processing', 'Processing...');
        } else if (integrationData.failedImport) {
            buttonText = this.$t('integrations.import-failed', 'Importing Failed');
        }

        return buttonText;
    }

    public buttonClasses(integrationData: IntegrationData): any {
        return {
            'hoc-btn': true,
            'hoc-btn-success': integrationData.imported,
            'hoc-btn-white': integrationData.disabled,
            'hoc-btn-add': (integrationData.readyForImport || integrationData.processing),
            'hoc-btn-danger': integrationData.failedImport,
        };
    }

    public iconClasses(integrationData: IntegrationData): any {
        return {
            'fal': true,
            'fa-check': integrationData.imported,
            'fa-ban': integrationData.disabled,
            'fa-play': integrationData.readyForImport,
            'fa-exclamation': integrationData.failedImport,
            'fa-spinner-third': integrationData.processing,
            'fa-spin spin': integrationData.processing,
        };
    }

    public previewOutput(integrationData: IntegrationData) {
        this.$store.commit(Mutations.SET_CURRENT_INTEGRATION_SINGLE_DATA_OUTPUT, integrationData);
        this.$store.commit(Mutations.SET_CURRENT_INTEGRATION_OUTPUT_OVERLAY_VISIBILITY, true);
    }

    public setIntegration(value: any) {
        if (!value.target.value) {
            return;
        }

        this.currentIntegrationId = value.target.value;

        this.$store.commit(Mutations.SET_CURRENT_INTEGRATION, this.currentIntegrationId);
        this.$store.dispatch(Actions.FETCH_CURRENT_INTEGRATION_DATA);
    }

    public uploadDataModal() {
        if (!this.currentIntegrationId) {
            return this.notify('please_select_integration_first', 'warning');
        }

        this.$store.commit(Mutations.SET_ADD_INTEGRATION_VISIBILITY, true);
    }

    public importIntegrationData(entryGuid: string) {
        this.$store.dispatch(Actions.QUEUE_INTEGRATION_DATA_IMPORT, {
            guid: entryGuid,
            vue: this,
        });
    }


    public mounted() {
        this.$store.dispatch(Actions.FETCH_INTEGRATION_TYPES);
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.RESET_INTEGRATIONS);
    }
}
